import { v4 as uuid } from 'uuid';
import StorageContants from '../config/storage.constants';
import { LocalStorage } from '../customer-call-sdk';
import { UUID } from '../types';
import * as sentry from '@sentry/react';

export function generateDeviceId(): UUID {
    const deviceId = uuid();
    LocalStorage.set(StorageContants.UNIQUE_DEVICE_ID, deviceId);
    return deviceId;
}

export function getDeviceId(): UUID {
    const deviceId = LocalStorage.get(StorageContants.UNIQUE_DEVICE_ID);

    if (!deviceId) {
        sentry.captureException(new Error('Device ID not found in localStorage'));
        return '';
    }
    return deviceId;
}
